var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const XBOX = "xbox";
const XBOX_ONE = "Xbox One";
function xboxExtension(options = {}) {
  return (context) => {
    const { avia, logger, system } = context;
    if (!/Xbox; Xbox One/.test(system.userAgent)) {
      return;
    }
    avia.configure({
      system: {
        device: XBOX_ONE,
        os: avia.Os.WINDOWS,
        platform: avia.Platform.WINDOWS
      }
    });
    avia.registerHook(avia.AviaHookType.DEVICE_CAPABILITIES, avia.Util.cache("xboxCapabilities", () => (context2) => __async(this, null, function* () {
      const keySystem = "com.microsoft.playready";
      const testCodecs = () => __async(this, null, function* () {
        const codecs = [
          {
            mimeType: options.dolbyAtmos || 'audio/mp4; codecs="ec-3"',
            property: "supportsDolbyAtmos"
          },
          {
            mimeType: options.dolbyVision || 'video/mp4; codecs="dvhe.05.06"',
            property: "supportsDolbyVision"
          },
          {
            mimeType: options.hevc || 'video/mp4; codecs="hvc1.2.4.L63.90"',
            property: "supportsHevc"
          },
          {
            mimeType: options.hdr10 || 'video/mp4; codecs="hev1.2.6.L93.90"',
            property: "supportsHdr10"
          }
        ];
        const support2 = {
          supportsDolbyAtmos: false,
          supportsDolbyVision: false,
          supportsHdr10: false,
          supportsHevc: false
        };
        for (const codec of codecs) {
          try {
            const config = {
              initDataTypes: ["cenc"],
              videoCapabilities: [
                {
                  contentType: codec.mimeType,
                  robustness: options.robustness || "HW_SECURE_ALL"
                }
              ]
            };
            const access = yield navigator.requestMediaKeySystemAccess(keySystem, [config]);
            const mk = yield access.createMediaKeys();
            support2[codec.property] = true;
          } catch (error) {
            logger.debug(error);
            support2[codec.property] = false;
          }
        }
        return support2;
      });
      const support = yield testCodecs();
      logger.debug("Capabilities as JSON: " + JSON.stringify(support));
      avia.Util.merge(context2.value, support);
    })));
  };
}
const ID = XBOX;
const extension = xboxExtension;
export {
  ID,
  XBOX,
  XBOX_ONE,
  extension,
  xboxExtension
};
//# sourceMappingURL=avia.xbox.esm.js.map
